export const PRIVACY_FRAGMENT = 'privacy-policy';
export const TERMS_FRAGMENT = 'terms-of-service';
